import React from 'react'
import PropTypes from 'prop-types'
import './Footer.scss'
import { routerTreePathConfig } from '@/routeTree'

export default class Animation extends React.PureComponent {
  render() {
    return (
      <div className='animation-con'>
        <img src='//img.ebei99.com/official-website/footer-wave.png' alt='' />
        <div className='footer-img-hover aek-vertical-left'>
          <img src='//img.ebei99.com/official-website/footer-wave-hover.png' alt='' />
          <img src='//img.ebei99.com/official-website/footer-wave-hover.png' alt='' />
          <img src='//img.ebei99.com/official-website/footer-wave-hover.png' alt='' />
        </div>
        <div className='middle-con'>
          <p className='slogan'>
            <span className='slogan-pc'>直击医院管理需求，提供数智化解决方案与服务。</span>
            <span className='slogan-m'>
              直击医院管理需求，提供数智化
              <br />
              解决方案与服务。
            </span>
          </p>
          <div className='btn-con'>
            <div className='left-btn' onClick={() => this.props.history.push(routerTreePathConfig.FreeTrial)}>
              免费试用
            </div>
            <div className='right-btn' onClick={() => this.props.history.push(routerTreePathConfig.FreeTrial)}>
              预约演示
            </div>
          </div>
        </div>
      </div>
    )
  }
}
